import { render, staticRenderFns } from "./LayoutBroker.vue?vue&type=template&id=37117f50&"
import script from "./LayoutBroker.vue?vue&type=script&lang=js&"
export * from "./LayoutBroker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports